import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { UrlUtilsService } from './url-utils.service';

@Pipe({
  name: 'imageUrl',
})
export class ImageUrlPipe implements PipeTransform {
  constructor(private urlUtil: UrlUtilsService) {}

  transform(path: string): string {
    return this.urlUtil.imageUrl(path);
  }
}

@NgModule({
  exports: [ImageUrlPipe],
  declarations: [ImageUrlPipe],
})
export class ImageUrlPipeModule {}
